import React, { useContext, useEffect, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import "../../../assets/css/style.css";
import { expert } from "../../../axiosConfig";
import { Context } from "../../../contexts/Store";
import ComingSoon from "../../genaral/ComingSoon";
import DashboardHeader from "../../genaral/DashboardHeader";
import DashboardLayout from "../../genaral/DashboardLayout";
import Page404 from "../../genaral/Page404";
import AboutPage from "../../screens/about/AboutPage";
import CaseReportPage from "../../screens/case_report/CaseReportPage";
import ContactPage from "../../screens/contact/ContactPage";
import Dashboard from "../../screens/dashboard/Dashboard";
import FaqsPage from "../../screens/faqs/FaqsPage";
import CustomerPage from "../../screens/customer/CustomerPage";
import CustomerEntry from "../../screens/customer/CustomerEntry";
import ManageProfilePage from "../../screens/manage_profile/ManageProfilePage";
import MyAccountPage from "../../screens/my_account/MyAccountPage";
import Notification from "../../screens/notification/Notification";
import CaseReportList from "../../screens/reports_list/CaseReportList";
import ReportsListPage from "../../screens/reports_list/ReportsListPage";
import SessionSummaryReportList from "../../screens/reports_list/SessionSummaryReportList";
import ScheduleCalendar from "../../screens/schedule-calendar/ScheduleCalendar";
import SlotDetailedView from "../../screens/schedule-calendar/SlotDetailedView";
import SessionSummaryPage from "../../screens/session_summary/SessionSummaryPage";
import SessionSinglePage from "../../screens/sessionsinglepage/SessionSinglePage";
import Settings from "../../screens/settings/Settings";
import TermsAndConditions from "../../screens/terms_and_conditions/TermsAndConditions";
import PrivateRoute from "../routes/PrivateRoute";
import Lottie from "lottie-react";
import LoaderLottie from "../../../assets/lottie/LoaderLottie.json";
import NewSlotDetailPage from "../../screens/schedule-calendar/NewSlotDetailPage";
import UpdateSlotModal from "../../screens/session_summary/modals/UpdateSlotModal";
import TransactionListPage from "../../screens/my_account/TransactionListPage";
import Sidebar from "../../genaral/Sidebar";

function AppRouter() {
    const [phoneNumber, setPhoneNumber] = useState("");
    const { state, dispatch } = useContext(Context);
    const access_token = state.user_details.access_token;
    const [expertData, setExpertData] = useState([]);
    const [error, SetError] = useState("");
    const [isLoading, setIsLoading] = useState(true);

    const getExpertData = () => {
        setIsLoading(true);
        // if (access_token) {
        expert
            .get("/profile/", {
                headers: {
                    Authorization: `Bearer ${access_token}`,
                },
            })
            .then((response) => {
                const { StatusCode } = response.data;
                if (StatusCode == 6000) {
                    setExpertData(response.data.data);
                    dispatch({
                        type: "UPDATE_USER",
                        user_details: {
                            is_default_time_slot:
                                response.data.data?.is_default_time_slot,
                            session_exist: response.data.data?.session_exist,
                        },
                    });
                    setIsLoading(false);
                } else if (StatusCode == 6001) {
                    SetError(response);
                    setIsLoading(false);

                    // console.log(error, "error");
                }
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
                SetError(error.message);
                setIsLoading(false);
            });
        // }
    };
    useEffect(() => {
        getExpertData();
    }, []);

    return isLoading ? (
        <Lottie
            animationData={LoaderLottie}
            style={{
                height: "100vh",
                width: 150,
                margin: "auto",
            }}
        />
    ) : (
        <>
            <Routes>
                <Route
                    path="/dashboard"
                    element={
                        <PrivateRoute>
                            <DashboardLayout expertData={expertData}>
                                <Dashboard />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/"
                    element={
                        <PrivateRoute>
                            <DashboardLayout expertData={expertData}>
                                <Dashboard />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/session-single-page/:id"
                    element={
                        <PrivateRoute>
                            <DashboardLayout expertData={expertData}>
                                <SessionSinglePage />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/add-case-report/:id"
                    element={
                        <PrivateRoute>
                            <DashboardLayout  expertData={expertData}>
                            <CaseReportPage />
                                
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                ></Route>
                <Route
                    path="/contact"
                    element={
                        <PrivateRoute>
                            <DashboardLayout  expertData={expertData}>
                            <ContactPage />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                ></Route>
                <Route
                    path="/faqs"
                    element={
                        <PrivateRoute>
                            <DashboardLayout  expertData={expertData}>
                                <FaqsPage />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                ></Route>
                <Route
                    path="/customers"
                    element={
                        <PrivateRoute>
                            <DashboardLayout expertData={expertData} >{" "}
                                <CustomerPage />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                ></Route>
                <Route
                    path="/customer-entry"
                    element={
                        <PrivateRoute>
                            <DashboardLayout expertData={expertData} >{" "}
                                <CustomerEntry />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                ></Route>
                <Route
                    path="/terms-and-conditions"
                    element={
                        // <PrivateRoute>
                        [
                            <DashboardLayout expertData={expertData} />,
                            <TermsAndConditions />,
                        ]
                        // </PrivateRoute>
                    }
                ></Route>
                <Route
                    path="/about"
                    element={
                        <PrivateRoute>
                            <DashboardLayout expertData={expertData} />{" "}
                            <AboutPage />
                        </PrivateRoute>
                    }
                ></Route>
                <Route
                    path="/manage-profile"
                    element={
                        <PrivateRoute>
                            <DashboardLayout expertData={expertData} />{" "}
                            <ManageProfilePage />
                        </PrivateRoute>
                    }
                ></Route>
                <Route
                    path="/reports-list"
                    element={
                        <PrivateRoute>
                            <DashboardLayout expertData={expertData} >
                                <ReportsListPage />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                ></Route>
                <Route
                    path="/reports-list/case-reports"
                    element={
                        <PrivateRoute>
                            <DashboardLayout expertData={expertData} >{" "}
                            <CaseReportList />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                ></Route>
                <Route
                    path="/transactions-list"
                    element={
                        <PrivateRoute>
                            <DashboardLayout expertData={expertData} >{" "}
                            <TransactionListPage />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                ></Route>
                <Route
                    path="/reports-list/summary-reports"
                    element={
                        <PrivateRoute>
                            <DashboardLayout expertData={expertData} >{" "}
                            <SessionSummaryReportList />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                ></Route>
                <Route
                    path="/my-account"
                    element={
                        <PrivateRoute>
                            <DashboardLayout expertData={expertData} >
                            <MyAccountPage />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                ></Route>
                <Route
                    path="/notifications"
                    element={
                        <PrivateRoute>
                            <DashboardLayout expertData={expertData} >
                            <Notification />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                ></Route>

                <Route
                    path="/schedule-calendar"
                    element={
                        <PrivateRoute>
                            <DashboardLayout expertData={expertData} >{" "}
                            <ScheduleCalendar />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/schedule-page"
                    element={
                        <PrivateRoute>
                            <DashboardLayout expertData={expertData} >{" "}
                            <NewSlotDetailPage />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                />

                <Route exact path="/coming-soon" element={<ComingSoon />} />

                <Route exact path="/404" element={<Page404 />} />
                <Route exact path="*" element={<Navigate to="/404" />} />
            </Routes>
        </>
    );
}

export default AppRouter;
